(function () {
    if (window.JGSubWidget) { window.JGSubWidget.refresh(); return; }

    var SEL = {
      widget: '[data-jg-sub]',
      option: '[data-jg-sub-option]',
      groupInput: '[data-jg-sub-group-input]',
      planInput: '[data-jg-sub-plan-input]',
      planIdInput: '[data-jg-sub-plan-id]',
      variantIdInput: '[data-jg-sub-variant-id]',
      productJson: '[data-jg-sub-product-json]',
      oncePrice: '[data-jg-sub-once-price]',
      onceCompare: '[data-jg-sub-once-compare]',
      subPrice: '[data-jg-sub-price]',
      subCompare: '[data-jg-sub-compare]',
      badge: '[data-jg-sub-badge]',
      // Theme product form (Dawn first, then any add-to-cart form)
      productForm: 'form[data-type="add-to-cart-form"], form[action*="/cart/add"]',
      // Variant pickers whose "change" should re-render prices
      variantTriggers: '[name="id"], .single-option-selector, variant-radios, variant-selects, [name^="options["]'
    };

    /* ── helpers ─────────────────────────────────────────────────────── */
    function getProduct(widget) {
      if (widget._jgProduct) return widget._jgProduct;
      var el = widget.querySelector(SEL.productJson);
      try { widget._jgProduct = JSON.parse(el.textContent); } catch (e) { widget._jgProduct = null; }
      return widget._jgProduct;
    }

    function getProductForm(widget) {
      var formId = widget.getAttribute('data-jg-sub-form-id');
      var byId = formId ? document.getElementById(formId) : null;
      if (byId && byId.tagName === 'FORM') return byId;
      return widget.closest('form') || document.querySelector(SEL.productForm);
    }

    function formatMoney(widget, cents) {
      var format = widget.getAttribute('data-jg-sub-money-format') || '$' + '{' + '{amount}' + '}';
      var amount = (parseInt(cents, 10) || 0) / 100;
      function withDelims(num, precision, thousands, decimal) {
        var parts = num.toFixed(precision).split('.');
        parts[0] = parts[0].replace(/(\d)(?=(\d{3})+$)/g, '$1' + thousands);
        return parts.length > 1 ? parts[0] + decimal + parts[1] : parts[0];
      }
      return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
        switch (key) {
          case 'amount_no_decimals': return withDelims(amount, 0, ',', '.');
          case 'amount_with_comma_separator': return withDelims(amount, 2, '.', ',');
          case 'amount_no_decimals_with_comma_separator': return withDelims(amount, 0, '.', ',');
          case 'amount_with_apostrophe_separator': return withDelims(amount, 2, "'", '.');
          default: return withDelims(amount, 2, ',', '.');
        }
      });
    }

    function getVariant(widget) {
      var product = getProduct(widget);
      if (!product) return null;
      var ids = product.variants.map(function (v) { return v.id; });
      var id = null;

      // 1. Theme product form's variant input
      var form = getProductForm(widget);
      var idInput = form && form.querySelector('[name="id"]');
      if (idInput && ids.indexOf(parseInt(idInput.value, 10)) !== -1) id = parseInt(idInput.value, 10);

      // 2. URL ?variant= (only if it belongs to this product)
      if (!id) {
        var urlId = parseInt(new URLSearchParams(window.location.search).get('variant'), 10);
        if (ids.indexOf(urlId) !== -1) id = urlId;
      }

      // 3. Liquid-rendered fallback
      if (!id) {
        var hidden = widget.querySelector(SEL.variantIdInput);
        id = hidden ? parseInt(hidden.value, 10) : null;
      }

      return product.variants.filter(function (v) { return v.id === id; })[0] || product.variants[0];
    }

    function getSelectedPlanId(widget) {
      var group = widget.querySelector(SEL.groupInput + ':checked');
      if (!group || group.value === 'once') return null;
      var plan = widget.querySelector('input[name="bsub-selling-plan-' + group.value + '"]:checked');
      return plan ? plan.value : null;
    }

    /* ── state sync: hidden input + theme product form + Bold SDK ────── */
    function syncSellingPlan(widget) {
      var planId = getSelectedPlanId(widget);
      var hidden = widget.querySelector(SEL.planIdInput);
      if (hidden) {
        if (planId) { hidden.setAttribute('name', 'selling_plan'); hidden.value = planId; }
        else { hidden.removeAttribute('name'); hidden.value = ''; }
      }

      // Keep the theme's own product form in sync so its Add-to-cart works too.
      var form = getProductForm(widget);
      if (form && !form.contains(hidden)) {
        var input = form.querySelector('input[name="selling_plan"]');
        if (planId) {
          if (!input) {
            input = document.createElement('input');
            input.type = 'hidden';
            input.name = 'selling_plan';
            form.appendChild(input);
          }
          input.value = planId;
        } else if (input) {
          input.remove();
        }
      }
    }

    /* ── Add-to-cart button price: per-delivery price when a plan is chosen ── */
    function syncButtonPrice(widget, variant) {
      var form = getProductForm(widget);
      var priceEl = form && form.querySelector('.product-form__submit-price');
      if (!priceEl) return;
      if (!variant.available) { priceEl.textContent = ''; return; }

      var price = variant.price;
      var planId = getSelectedPlanId(widget);
      if (planId) {
        var alloc = (variant.selling_plan_allocations || []).filter(function (a) {
          return String(a.selling_plan_id) === String(planId);
        })[0];
        if (alloc) price = alloc.per_delivery_price;
      }
      priceEl.textContent = '- ' + formatMoney(widget, price);
    }

    /* ── render prices/badge/availability for the current variant ───── */
    function render(widget) {
      var variant = getVariant(widget);
      if (!variant) return;
      var money = function (c) { return formatMoney(widget, c); };

      // One-time row
      var oncePrice = widget.querySelector(SEL.oncePrice);
      var onceCompare = widget.querySelector(SEL.onceCompare);
      if (oncePrice) oncePrice.textContent = money(variant.price);
      if (onceCompare) {
        var showOnceCompare = variant.compare_at_price && variant.compare_at_price > variant.price;
        onceCompare.hidden = !showOnceCompare;
        if (showOnceCompare) onceCompare.textContent = money(variant.compare_at_price);
      }

      // Subscribe rows
      widget.querySelectorAll('[data-jg-sub-group-id]').forEach(function (row) {
        var groupId = row.getAttribute('data-jg-sub-group-id');
        var planInput = row.querySelector('input[name="bsub-selling-plan-' + groupId + '"]:checked')
                     || row.querySelector(SEL.planInput);
        var planId = planInput ? planInput.value : null;
        var alloc = (variant.selling_plan_allocations || []).filter(function (a) {
          return String(a.selling_plan_id) === String(planId);
        })[0];

        var price = alloc ? alloc.per_delivery_price : variant.price;
        var compare = null;
        if (variant.compare_at_price && variant.compare_at_price > price) compare = variant.compare_at_price;
        else if (variant.price > price) compare = variant.price;
        var pct = variant.price > 0 && price < variant.price
          ? Math.round((variant.price - price) * 100 / variant.price) : 0;

        var priceEl = row.querySelector(SEL.subPrice);
        var compareEl = row.querySelector(SEL.subCompare);
        var badgeEl = row.querySelector(SEL.badge);
        if (priceEl) priceEl.textContent = money(price);
        if (compareEl) { compareEl.hidden = !compare; if (compare) compareEl.textContent = money(compare); }
        if (badgeEl) { badgeEl.hidden = pct <= 0; badgeEl.textContent = pct + '% OFF'; }
      });

      syncButtonPrice(widget, variant);
    }

    function activate(widget) {
      widget.querySelectorAll(SEL.option).forEach(function (opt) {
        var input = opt.querySelector(SEL.groupInput);
        opt.classList.toggle('is-active', !!(input && input.checked));
      });
    }

    /* ── wire up one widget ──────────────────────────────────────────── */
    function init(widget) {
      if (widget._jgInit) return;
      widget._jgInit = true;

      widget.addEventListener('change', function (e) {
        var t = e.target;
        if (t.matches(SEL.groupInput)) {
          activate(widget);
          syncSellingPlan(widget);
          render(widget);
          if (window.BOLD && window.BOLD.BsubWidget) {
            try { window.BOLD.BsubWidget.handleSellingPlanGroupChange(e); } catch (err) {}
          }
        } else if (t.matches(SEL.planInput)) {
          syncSellingPlan(widget);
          render(widget);
          if (window.BOLD && window.BOLD.BsubWidget) {
            try { window.BOLD.BsubWidget.handleSellingPlanChange(e); } catch (err) {}
          }
        }
      });


      activate(widget);
      syncSellingPlan(widget);
      render(widget);
    }

    function refresh() {
      document.querySelectorAll(SEL.widget).forEach(function (w) { init(w); syncSellingPlan(w); render(w); });
    }

    // Some themes re-render the buy-button form on variant change, which
    // would drop the injected input. Re-sync right before any cart form submits.
    document.addEventListener('submit', function (e) {
      if (e.target.matches && e.target.matches(SEL.productForm)) {
        document.querySelectorAll(SEL.widget).forEach(syncSellingPlan);
      }
    }, true);

    // Re-render when the theme's variant picker changes (small delay lets the
    // theme update its [name="id"] input / URL first).
    document.addEventListener('change', function (e) {
      if (e.target.closest && e.target.closest(SEL.variantTriggers)) setTimeout(refresh, 80);
    });
    window.addEventListener('popstate', refresh);

    // Dawn's product-info.js rewrites the button price from fresh section HTML
    // after a variant change; re-apply the selected plan's price once it's done.
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
      subscribe(PUB_SUB_EVENTS.variantChange, function () { refresh(); });
    }

    window.JGSubWidget = { refresh: refresh, render: render };

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refresh);
    else refresh();
  })();


/* ── Related products slider (Embla) ─────────────────────────────────────
 * Generic Embla initialiser for any .embla wrapper on the product page,
 * plus a watcher for <product-recommendations>, which is injected late.
 * ───────────────────────────────────────────────────────────────────── */
function initEmblaCarousels() {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  document.querySelectorAll('.embla:not([data-embla-initialized])').forEach((wrapperNode) => {
    if (wrapperNode.dataset.emblaDeferred === 'true') return;

    const viewportNode = wrapperNode.querySelector('.embla__viewport');
    if (!viewportNode || typeof EmblaCarousel === 'undefined') return;

    wrapperNode.dataset.emblaInitialized = 'true';

    const loopEnabled = wrapperNode.dataset.loop !== 'false';

    const emblaApi = EmblaCarousel(viewportNode, {
      loop: loopEnabled,
      align: 'start',
      slidesToScroll: 1,
    });

    const prevButtonNode = wrapperNode.querySelector('.embla__prev');
    const nextButtonNode = wrapperNode.querySelector('.embla__next');

    const updateNavButtons = () => {
      if (!prevButtonNode || !nextButtonNode) return;

      if (loopEnabled && emblaApi.scrollSnapList().length > 1) {
        prevButtonNode.disabled = false;
        nextButtonNode.disabled = false;
        return;
      }

      prevButtonNode.disabled = !emblaApi.canScrollPrev();
      nextButtonNode.disabled = !emblaApi.canScrollNext();
    };

    prevButtonNode?.addEventListener('click', () => emblaApi.scrollPrev(), false);
    nextButtonNode?.addEventListener('click', () => emblaApi.scrollNext(), false);

    emblaApi.on('select', updateNavButtons);
    emblaApi.on('reInit', updateNavButtons);
    updateNavButtons();

    const autoplayEnabled =
      wrapperNode.dataset.autoplay === 'true' || wrapperNode.getAttribute('autoplay') === 'true';

    if (!autoplayEnabled || reducedMotion || emblaApi.scrollSnapList().length <= 1) return;

    const delay = Number(wrapperNode.dataset.autoplayDelay || 5000);
    let autoplayTimer = null;

    const play = () => {
      stop();
      autoplayTimer = window.setInterval(() => emblaApi.scrollNext(), delay);
    };

    const stop = () => {
      if (autoplayTimer !== null) {
        window.clearInterval(autoplayTimer);
        autoplayTimer = null;
      }
    };

    play();

    wrapperNode.addEventListener('mouseenter', stop);
    wrapperNode.addEventListener('mouseleave', play);

    document.addEventListener('visibilitychange', () => {
      document.hidden ? stop() : play();
    });
  });
}

window.initEmblaCarousels = initEmblaCarousels;

/* <product-recommendations> fetches its markup on scroll, so the slider it
 * contains only exists after the injection. Initialise what is already in the
 * DOM, then re-run whenever a recommendations element swaps its contents. */
(function () {
  function boot() {
    initEmblaCarousels();

    var observer = new MutationObserver(function () {
      initEmblaCarousels();
    });

    document.querySelectorAll('product-recommendations').forEach(function (element) {
      observer.observe(element, { childList: true, subtree: true });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();


/* ── Read more / read less ───────────────────────────────────────────────
 * Collapses any [data-read-more] block to the first two lines of its text
 * (eyebrows and headings stay visible) and adds a toggle at the end.
 * ───────────────────────────────────────────────────────────────────── */
(function () {
  var SKIP = '.hp-eyebrow, h1, h2, h3, h4, h5, h6';
  var SKIP_CHILD = SKIP.split(', ').map(function (s) { return ':scope > ' + s; }).join(', ');
  var LINES = 2;

  // The nearest block element holding a text node. An inline element that
  // shares its parent with a heading is used as is, so the heading stays out.
  function blockOf(node, container) {
    var el = node.parentElement;
    while (el !== container && getComputedStyle(el).display === 'inline' && !el.parentElement.querySelector(SKIP_CHILD)) {
      el = el.parentElement;
    }
    return el === container ? null : el;
  }

  // The first LINES rendered lines of body text, each with its block element.
  function findLines(container) {
    var walker = document.createTreeWalker(container, NodeFilter.SHOW_TEXT, {
      acceptNode: function (node) {
        if (!node.textContent.trim() || node.parentElement.closest(SKIP)) return NodeFilter.FILTER_SKIP;
        return NodeFilter.FILTER_ACCEPT;
      }
    });
    var lines = [];
    var range = document.createRange();
    var node;
    while (lines.length < LINES && (node = walker.nextNode())) {
      var block = blockOf(node, container);
      if (!block) continue;
      range.selectNodeContents(node);
      var rects = range.getClientRects();
      for (var i = 0; i < rects.length && lines.length < LINES; i++) {
        var last = lines[lines.length - 1];
        if (!rects[i].height || (last && Math.abs(rects[i].top - last.top) < 4)) continue;
        lines.push({ top: rects[i].top, block: block });
      }
    }
    return lines;
  }

  function init(container) {
    if (container._readMore) return;

    var lines = findLines(container);
    if (!lines.length) return;
    container._readMore = true;

    // Clamp the block holding the last kept line to the lines it contributes.
    var target = lines[lines.length - 1].block;
    var targetLines = lines.filter(function (l) { return l.block === target; }).length;

    // Everything after that block, at every level up to the container.
    var rest = [];
    for (var el = target; el !== container; el = el.parentElement) {
      for (var sib = el.nextElementSibling; sib; sib = sib.nextElementSibling) rest.push(sib);
    }

    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'read-more-toggle';
    container.appendChild(button);

    var collapsed;
    function setCollapsed(value) {
      collapsed = value;
      target.classList.toggle('read-more-clamp', value);
      target.style.setProperty('--read-more-lines', targetLines);
      rest.forEach(function (item) { item.classList.toggle('read-more-hidden', value); });
      button.textContent = value ? 'Read more' : 'Read less';
      button.setAttribute('aria-expanded', String(!value));
    }

    setCollapsed(true);
    // Nothing to hide: the text already fits in the kept lines.
    if (!rest.length && target.scrollHeight <= target.clientHeight + 1) {
      setCollapsed(false);
      button.remove();
      return;
    }
    button.addEventListener('click', function () { setCollapsed(!collapsed); });
  }

  function boot() {
    document.querySelectorAll('[data-read-more]').forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
